import { Alert, AlertTitle } from "@mui/material";
import { useContext } from "react";
import useLocales from "src/hooks/useLocales";
import useResponsive from "src/hooks/useResponsive";

import Context from "../context";

// ----------------------------------------------------------------------

export const SuccessResult = () => {
	const { customConnectProps } = useContext(Context);
	const isMobile = useResponsive("down", "sm");
	const { translate } = useLocales();

	const { updateToken, restoreToken } = customConnectProps!;

	const message = updateToken
		? translate("link.update_success")
		: restoreToken
		? translate("link.restore_success")
		: isMobile
		? translate("link.connection_success_mobile")
		: translate("link.connection_success");

	return (
		<Alert severity='success'>
			<AlertTitle>{message}</AlertTitle>
			{translate("link.redirecting")}
		</Alert>
	);
};

export default SuccessResult;
